<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<h2>Update Volume Estimate</h2>
			</b-col>
		</div>

		<div>
			<b-card>
				<b-row>
					<b-col md="4">
                        <b-form-group :label-cols="4" id="L1" label="Excel File" label-for="csv" horizontal>
                            <input type="file" id="files" accept=".xls, .xlsx" ref="file" v-on:change="handleFileUpload()" />
                        </b-form-group>
                    </b-col>                  
				</b-row>
				<b-row>
					<b-col md="4">
                        <b-button size="md" variant="primary" @click="sendCSV" class="float-left">Update</b-button>
                    </b-col>                  
				</b-row>                 
                <b-row v-if="progress">
                    <b-col v-if="load_csv==='Loading Excel file.....'" md="12">
                        <h5 class="text-center mt-3"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i> {{load_csv }}</h5>
                       <!--  <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress> -->
                    </b-col>
                    <b-col v-else md="12">
                        <h5 class="text-center mt-3" >{{load_csv }}</h5>
                        <!-- <b-progress :value="uploadPercentage" :max="100" show-progress animated class="mb-3"></b-progress> -->
                    </b-col>
                 </b-row>   

			</b-card>
		</div>
	</div>
</template>

<script>
    import pwbi_service from './isolera_service'
    import axios from 'axios'
    import {apiDomain} from '../../config'
	export default {
		name: 'VolumeEstimate',
		data() {
			return {
				model           : {
                    csv              : '',
				},
                role            : '',  
                file            : '',  
                url             : '',
                load_csv        : 'Loading Excel file.....',
                uploadPercentage: 0,
                progress        : false
			}
		},
		methods: {
            base64ToBlob(base64) {
  		        const binaryString = window.atob(base64);
  		        const len = binaryString.length;
  		        const bytes = new Uint8Array(len);
  		        for (let i = 0; i < len; ++i) {
    		        bytes[i] = binaryString.charCodeAt(i);
  		        }
  		        return new Blob([bytes], { type: 'application/csv' });
            },
            handleFileUpload() {
                this.file       = this.$refs.file.files[0]
                this.model.csv  = this.file['name']
                let url         = window.URL.createObjectURL(this.file)
                this.url        = url
				setTimeout(() => window.URL.revokeObjectURL(url), 100)
            },
            okToSave() {

                if (this.model.csv === '') {
                    this.$swal('Alert!', 'Please, Enter Excel file', 'warning')
                    return false
                }          
                return true
            },
            sendCSV () {
                if (!this.okToSave()) {
                    return
                }  
                this.savebtn                = true
                const json = JSON.stringify(this.model);
                const blob = new Blob([json], {
                type: 'application/json'
                })
                let formData = new FormData()
                formData.append("document", blob)
                formData.append('file', this.file)
                this.uploadPercentage   = 0
                this.progress           = true     
                this.load_csv           = 'Sending Excel file.....'
                this.send_csv ( formData )
            },  
            send_csv ( formData ) {

			    axios.post(apiDomain + '/send_csv/', formData, { headers: {
				  'Content-Type': 'multipart/form-data',
			        'token': localStorage.getItem('access_token')
                },
                    onUploadProgress: ( progressEvent ) => {
                        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
                    }
                })
				    .then((response) => {
                        let data = response.data
                        if (data.status == 'success') {
                            this.load_csv           = 'Volume Estimate Updated'
                            this.$swal(data.status, data.message, data.status)
                            this.progress           = false
                        } else {
                            this.load_csv        = 'Loading Excel file.....',
                            this.uploadPercentage= 0,
                            this.progress        = false                            
                            this.$swal(data.status, data.message, data.status)
                        }
				    })
				    .catch((error) => {
                        this.load_csv        = 'Loading Excel file.....',
                        this.uploadPercentage= 0,
                        this.progress        = false
                        this.$swal('Error', 'Server not response. ' + error, 'error')
				  })
	    },         
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/isolera/update_volume_estimate.vue